import React from 'react';

const TermsAndConditionsDe = () => {
  return (
    <div
      style={{
        padding: '48px',
        lineHeight: '1.6',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <h1>Allgemeine Geschäftsbedingungen (AGB) für Fotogram Technology</h1>
      <p>
        <strong>Stand:</strong> 22.11.2024
      </p>

      <section>
        <h2>1. Präambel</h2>
        <p>
          Willkommen bei Fotogram Technology! Fotogram Technology bietet eine
          innovative Plattform für Fotografen, die ihre Effizienz steigern, ihre
          Marke stärken und ihren Kunden ein einzigartiges Erlebnis bieten
          möchten. Mit Funktionen wie CRM-Tools, Kalenderintegration,
          Live-Bildübertragung, AI-gestützter Gesichtserkennung und digitalem
          Albumdesign unterstützt Fotogram Technology Fotografen, ihre
          Arbeitsprozesse zu optimieren und ihr Geschäft zu erweitern. Durch die
          Nutzung von Fotogram Technology erklären Sie sich mit diesen
          Allgemeinen Geschäftsbedingungen (AGB) einverstanden.
        </p>
      </section>

      <section>
        <h2>2. Geltungsbereich</h2>
        <p>
          2.1 Diese AGB gelten für alle Nutzer der Plattform Fotogram
          Technology, unabhängig von ihrem Standort.
        </p>
        <p>
          2.2 Abweichende oder ergänzende Geschäftsbedingungen der Nutzer werden
          nur anerkannt, wenn Fotogram Technology diesen ausdrücklich
          schriftlich zugestimmt hat.
        </p>
        <p>
          2.3 Mit der Registrierung und Nutzung der Plattform erkennen die
          Nutzer die AGB in ihrer jeweils aktuellen Fassung an.
        </p>
        <p>
          2.4 Diese Plattform richtet sich ausschließlich an Unternehmer im Sinne des §14 BGB. 
          Eine Nutzung durch Verbraucher ist ausgeschlossen.
        </p>
      </section>

      <section>
        <h2>3. Vertragsschluss und Registrierung</h2>
        <p>
          3.1 Die Nutzung von Fotogram Technology beginnt mit der erfolgreichen
          Registrierung und dem erstmaligen Einloggen.
        </p>
        <p>
          3.2 Fotogram Technology bietet eine kostenlose Testphase von 30 Tagen.
          Nach Ablauf der Testphase wird der Account automatisch auf den
          kostenlosen Tarif zurückgestuft, sofern keine Zahlungsdaten hinterlegt
          werden.
        </p>
        <p>
          3.3 Nutzer können kostenpflichtige Funktionen jederzeit durch die
          Eingabe ihrer Zahlungsinformationen aktivieren.
        </p>
      </section>

      <section>
        <h2>4. Leistungen von Fotogram Technology</h2>
        <p>
          4.1 Fotogram Technology bietet Fotografen unter anderem folgende
          Funktionen:
        </p>
        <ul>
          <li>
            Speicherplatz und Galerien: Speicherung und Verwaltung von Bildern
            sowie die Erstellung digitaler Galerien.
          </li>
          <li>
            CRM-Tools: Verwaltung von Kunden, Verträgen und Veranstaltungen.
          </li>
          <li>
            AI-Funktionen: Gesichtserkennung und Echtzeit-Bildübertragung.
          </li>
          <li>
            Kalenderintegration: Synchronisation mit geschäftlichen Kalendern.
          </li>
          <li>
            Digitales Albumdesign: Erstellung personalisierter Alben aus über
            400 Vorlagen.
          </li>
          <li>
            Live-Bildübertragung: Echtzeit-Bildfreigabe während Veranstaltungen
            über QR-Codes.
          </li>
          <li>
            Multilinguale Bedienung: Die Plattform ist in mehreren Sprachen
            verfügbar.
          </li>
          <li>
            Digitaler Shop: Integration eines Shops für Druckservices oder
            andere Produkte.
          </li>
        </ul>
        <p>
          4.2 Fotogram Technology behält sich das Recht vor, die angebotenen
          Leistungen zu erweitern, einzuschränken oder zu ändern, sofern dies
          für die Nutzer zumutbar ist.
        </p>
      </section>

      <section>
        <h2>5. Pflichten der Nutzer</h2>
        <p>
          5.1 Der Nutzer ist verpflichtet, bei der Registrierung vollständige
          und wahrheitsgemäße Angaben zu machen. Änderungen sind unverzüglich
          mitzuteilen.
        </p>
        <p>
          5.2 Die Zugangsdaten des Nutzers sind vertraulich zu behandeln und
          dürfen nicht an Dritte weitergegeben werden.
        </p>
        <p>
          5.3 Der Nutzer darf die Plattform nicht missbräuchlich nutzen,
          insbesondere:
        </p>
        <ul>
          <li>
            keine rechtswidrigen, diffamierenden oder obszönen Inhalte
            hochladen;
          </li>
          <li>keine Urheberrechte oder Rechte Dritter verletzen;</li>
          <li>
            keine automatisierten Systeme verwenden, um auf die Plattform
            zuzugreifen.
          </li>
        </ul>
        <p>
          5.4 Der Nutzer bleibt für die Einhaltung der Urheberrechte an
          hochgeladenen Inhalten verantwortlich.
        </p>
      </section>

      <section>
        <h2>6. Widerrufsrecht für Verbraucher</h2>
        <p>
          Dieses Widerrufsrecht gilt ausschließlich für Verbraucher im Sinne des §13 BGB. 
          Da Fotogram Technology ausschließlich Unternehmer gemäß §14 BGB als Kunden akzeptiert, 
          ist ein Widerrufsrecht ausgeschlossen.
        <p></p>

          6.1 Verbraucher haben das Recht, innerhalb von 14 Tagen ohne Angabe
          von Gründen den Vertrag zu widerrufen.
        </p>
        <p>
          6.2 Zur Ausübung des Widerrufsrechts muss der Nutzer Fotogram
          Technology über seine Entscheidung in Textform (z. B. per E-Mail)
          informieren.
        </p>
        <p>
          6.3 Details zum Widerrufsrecht sind in der separaten
          Widerrufsbelehrung geregelt.
        </p>
      </section>

      <section>
        <h2>7. Preise, Steuern und Gebühren</h2>
        <p>
          7.1 Alle Preise verstehen sich, sofern nicht anders angegeben,
          zuzüglich Mehrwertsteuer oder anderer anwendbarer Steuern.
        </p>
        <p>
          7.2 Nutzer aus der EU sind verpflichtet, die steuerlichen Vorgaben ihres Landes einzuhalten. 
          Bei umsatzsteuerpflichtigen Leistungen an Unternehmen innerhalb der EU findet das Reverse-Charge-Verfahren gemäß 
          Art. 196 MwStSystRL Anwendung.
        </p>
        <p>
          7.3 Fotogram Technology behält sich das Recht vor, Preise für
          kostenpflichtige Funktionen anzupassen. Änderungen werden den Nutzern
          rechtzeitig mitgeteilt.
        </p>
      </section>

      <section>
        <h2>8. Haftung und Gewährleistung</h2>
        <p>
          8.1 Fotogram Technology haftet nur für Schäden, die durch
          vorsätzliches oder grob fahrlässiges Verhalten verursacht wurden.
        </p>
        <p>
          8.2 Die Haftung für indirekte Schäden, Datenverluste oder entgangene
          Gewinne ist ausgeschlossen, sofern diese nicht auf grober
          Fahrlässigkeit beruhen.
        </p>
        <p>
          8.3 Der Nutzer ist verantwortlich für regelmäßige Backups seiner
          Inhalte. Fotogram Technology haftet nicht für Datenverluste, die durch
          Benutzerfehler oder unvorhergesehene Ereignisse verursacht werden.
        </p>
        <p>
          8.4 Fotogram Technology haftet nicht für Ausfälle oder
          Einschränkungen, die durch höhere Gewalt oder Drittanbieter verursacht
          werden.
        </p>
      </section>

      <section>
        <h2>9. Datenschutz und Sicherheit</h2>
        <p>
          9.1 Fotogram Technology verarbeitet personenbezogene Daten gemäß der
          Datenschutz-Grundverordnung (DSGVO).
        </p>
        <p>
          9.2 Alle Daten werden ausschließlich auf Servern in Deutschland
          gespeichert. Die Datenverarbeitung erfolgt ausschließlich auf Servern in Deutschland, 
          die den Anforderungen der DSGVO und höchsten Sicherheitsstandards entsprechen. 
          Details zur Verarbeitung personenbezogener Daten finden Sie in der Datenschutzerklärung.
        </p>
        <p>
          9.3 Der Nutzer bleibt Eigentümer der von ihm hochgeladenen Inhalte.
          Fotogram Technology erhält lediglich eine eingeschränkte Lizenz zur
          Verarbeitung und Darstellung der Inhalte auf der Plattform.
        </p>
      </section>

      <section>
        <h2>10. Kündigung und Vertragslaufzeit</h2>
        <p>
          10.1 Die Vertragslaufzeit richtet sich nach dem vom Nutzer gewählten
          Abrechnungszeitraum.
        </p>
        <p>
          10.2 Der Vertrag kann jederzeit zum Ende des aktuellen
          Abrechnungszeitraums gekündigt werden.
        </p>
        <p>
          10.3 Fotogram Technology behält sich das Recht vor, den Vertrag
          fristlos zu kündigen, wenn der Nutzer gegen die AGB verstößt.
        </p>
      </section>

      <section>
        <h2>11. Schlussbestimmungen</h2>
        <p>
          11.1 Es gilt das Recht des Staates Israel, sofern keine zwingenden
          gesetzlichen Bestimmungen eines anderen Staates Vorrang haben.
        </p>
        <p>
          11.2 Für Streitigkeiten ist der Gerichtsstand Tel Aviv, Israel, soweit
          dies gesetzlich zulässig ist.
        </p>
        <p>
          11.3 Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt
          die Gültigkeit der übrigen Bestimmungen unberührt.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditionsDe;
